module.exports = "<div class=\"Form-multiselect\">\n  <div class=\"Form-select\">\n    <select ng-model=\"selectedItem\" ng-transclude>\n      <option value=\"\"></option>\n    </select>\n  </div>\n  <div class=\"Form-multiselectOption\" ng-repeat=\"item in selectedItems\">\n    <a ng-click=\"removeItem($index)\"><i class=\"Icon Icon-timesCircle\"></i></a>\n    <span ng-bind-html=\"::item.translationKey | translate\"></span>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/directives/multiselect.html
// module id = 483
// module chunks = 24